import { useQuery } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";
import { CustomReport } from "../types/CustomReport";
import { APP_PLATFORM_ID } from "@/config";
import qr from "query-string";

const GET_CUSTOM_REPORTS_FETCH_KEY = "GET_CUSTOM_REPORTS_KEY";

export const getCustomReports = async (
  zoneId: string,
): Promise<CustomReport[]> => {
  const queryParams = qr.stringify({
    zoneId,
    platformId: APP_PLATFORM_ID,
  });
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/custom-reports?${queryParams}`,
  );
  return response.data;
};

export const useGetCustomReports = (zoneId: string) => {
  const { data, isPending, error } = useQuery({
    queryKey: [GET_CUSTOM_REPORTS_FETCH_KEY, zoneId],
    queryFn: () => getCustomReports(zoneId),
  });

  return {
    data,
    isPending,
    error,
  };
};
